import React from 'react';
import { contentV2PropTypes } from './ContentV2PropTypes';
import Picture from '@Theme/natucare/components/Picture/Picture';
import * as styles from './ContentV2.module.scss';
const ContentV2 = ({
  picture,
  description,
  buttons,
  buttonHeading
}) => {
  if (!picture && !description) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootBody
  }, picture.src && picture.alt && /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: picture.src
    },
    alt: picture.alt,
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rootActions
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootButtonHeading
  }, buttonHeading), buttons && /*#__PURE__*/React.createElement("div", {
    className: styles.rootButtons
  }, buttons.map(({
    label,
    href
  }, index) => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, label && href && /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: href,
      className: styles.rootButton
    }, label));
  })))));
};
export default ContentV2;